import { useEffect, useLayoutEffect, useState } from "react";
import type { EntranceVariant } from "@/src/common/hooks/use-entrance";

export function useMountEntrance(disabled = false): EntranceVariant {
	const [state, setState] = useState<EntranceVariant>("visible");

	useLayoutEffect(() => {
		if (!disabled) setState("hidden");
	}, [disabled]);

	useEffect(() => {
		if (state !== "hidden") return;
		let inner = 0;
		const outer = window.requestAnimationFrame(() => {
			inner = window.requestAnimationFrame(() => setState("visible"));
		});
		return () => {
			window.cancelAnimationFrame(outer);
			window.cancelAnimationFrame(inner);
		};
	}, [state]);

	return state;
}
